<mat-dialog-content>
  <div class="main">
    <header class="header">
      <h2>{{ 'authModalTitle' | i18next }}</h2>
      <button class="header--btn" (click)="closeModal()">
        <img
          src="../../../../assets/icons/close.svg"
          alt="{{ 'btnClose' | i18next | uppercase }}"
        />
      </button>
    </header>
    <div class="content" *ngIf="!!data.list && data.list.length > 0">
      <h4 *ngIf="data.list.length > 1" class="content-title">
        {{ 'confirmAuthQ' | i18next }} <strong>{{ typeText }}</strong>
        {{ 'confirmPluralAuth' | i18next }}
      </h4>
      <h4 *ngIf="data.list.length === 1" class="content-title">
        {{ 'confirmAuthQ' | i18next }} <strong>{{ typeText }}</strong>
        {{ 'confirmOneAuth' | i18next }}
      </h4>
      <ul class="content--list">
        <li *ngFor="let auth of data.list">
          <p>
            {{
              auth.requestNumber
                ? auth.requestNumber
                : auth.redPlateId
                  ? auth.redPlateId
                  : auth.id
            }}
            {{ auth.petitioner ? '/ ' + auth.petitioner : '' }}
            {{ auth.vehicle?.model ? '/ ' + auth.vehicle?.model : '' }}
          </p>
        </li>
      </ul>
      <div class="content--textarea">
        <mat-form-field class="content--textarea__input">
          <mat-label>{{ 'observations' | i18next }}</mat-label>
          <textarea
            formControlName="comments"
            #comments
            (change)="changeComments(comments.value)"
            matInput
            placeholder="{{ 'observations' | i18next }}"
            rows="4"
            cols="50"
          ></textarea>
        </mat-form-field>
      </div>
      <mat-dialog-actions class="content--btnContainer">
        <button
          type="button"
          mat-button
          class="content--btnContainer__btn btn cancel"
          (click)="closeModal()"
        >
          {{ 'btnNo' | i18next | uppercase }}
        </button>
        <button
          type="button"
          mat-button
          class="content--btnContainer__btn"
          (click)="submitList()"
        >
          {{ 'btnYes' | i18next | uppercase }}
        </button>
      </mat-dialog-actions>
    </div>
    <p class="emptyMsg" *ngIf="listEmpty || data.list.length === 0">
      {{ 'noAuthSelected' | i18next }} {{ typeText }}
    </p>
  </div>
</mat-dialog-content>
